import React, { useRef } from 'react';
import ModelCard from '../../ModelCard';
import FlowCard from '../../FlowCard';
import CardShimmer from '../../CardShimmer';
import { useFetchList } from './useFetchList';
import { EmptyState } from '../../../base/modelLib/EmptyState';
import { applyModel } from '../../../../helpers';
import { Divider } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
import { modalType } from '../../../../constants';
import { useModelsModalState } from '../../../../store/state';
import { useScrollTop } from '../../../../hooks/useScrollTop';

const CollectWrapper = ({ cols, modelType, ratio }) => {
  const { loading, collectType } = useFetchList(modelType);
  const collectModels = useModelsModalState('collectModels');
  const ref = useRef(null);
  const { scroll } = useScrollTop(ref);

  if (loading) {
    return (
      <div className="flex flex-wrap">
        <CardShimmer ratio={ratio} cols={cols} />
      </div>
    );
  }
  const data = collectModels[collectType] ?? [];

  if (!data.length) return <EmptyState />;
  return (
    <div ref={ref} className="overflow-auto pl-4" onScroll={() => scroll()}>
      <div className="flex flex-wrap">
        {data.map((item) => {
          return modelType === modalType.WORKFLOW ? (
            <FlowCard data={item} key={item?.versionId} ratio={ratio} cols={cols} showAuthorInfo={false} />
          ) : (
            <ModelCard
              data={item}
              key={item?.versionId}
              ratio={ratio}
              cols={cols}
              showTag={true}
              query={''}
              onClick={applyModel}
              showAuthorInfo={false}
            />
          );
        })}
      </div>
      <Divider
        label={translate('history_bottom')}
        color="#EBEBEB"
        className="w-[40%] m-auto"
        styles={{ label: { fontSize: '12px', color: '#969696', lineHeight: '12px' } }}
      />
    </div>
  );
};

export default CollectWrapper;
